<script lang="ts" setup>
import { PropType, computed } from 'vue';
import { Wallet } from '@/shared/interfaces/balance';
import useUtils from '@/shared/composables/useUtils';

const props = defineProps({
	wallets: { type: Array as PropType<Wallet[]>, default: () => [] },
	selectedWallet: { type: Object as PropType<Wallet | undefined>, default: undefined },
});

const emit = defineEmits(['select']);

const { convertToCurrency } = useUtils();

const activeWallets = computed(() => props.wallets.filter((w) => +w.current_balance > 0));
</script>

<template>
	<div v-if="activeWallets.length > 0" class="flex gap-2 mb-2 overflow-x-auto wallet-badges-row mx-[34px]">
		<div
			v-for="wallet in activeWallets"
			:key="wallet.id"
			class="wallet-badge flex-shrink-0 cursor-pointer"
			:class="{ 'wallet-badge--active': selectedWallet?.id === wallet.id }"
			@click="emit('select', wallet)">
			{{ wallet.currency.prefix }} {{ convertToCurrency(+wallet.current_balance) }}
		</div>
	</div>
</template>

<style lang="scss" scoped>
.wallet-badges-row {
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
}

.wallet-badge {
	display: inline-flex;
	align-items: center;
	padding: 4px 10px;
	border-radius: 999px;
	font-family: 'sourcesanspro-regular', sans-serif;
	font-size: 12px;
	background: rgba(0, 0, 0, 0.2);
	color: rgba(255, 255, 255, 0.85);
	transition: all 0.2s ease;

	&--active {
		background: rgba(255, 255, 255, 0.25);
		color: #fff;
		font-family: 'sourcesanspro-bold', sans-serif;
	}

	&:active {
		transform: scale(0.95);
	}
}
</style>
